import { Service } from '@angular/core';
import { environment } from '@environments/environment';

@Service()
export class ConnectService {
  openFilloutForms(projectId: string, doorId: string): void {
    if (!projectId || !doorId) return;

    const url = `${environment.connectBaseUrl}projects/${projectId}/doors/${doorId}/forms/from-external?app=mbm`;
    const newTab = globalThis.open(url, '_blank');

    // Popup blockers can reject window.open, so fall back to a real anchor click.
    if (!newTab || newTab.closed) {
      this.createAndClickLink(url);
    }
  }

  private createAndClickLink(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
